<template>
  <div class="row justify-content-md-center">
    <div class="col-sm-6 col-sm-offset-3">
      <h2>Please Register</h2>
      <div v-if="errors && errors.length">
        <ul>
          <li v-for="(error, idx) in errors" :key="idx">{{ error }}</li>
        </ul>
      </div>
      <form class="form-horizontal" @submit.prevent="onSubmit">
        <div class="form-group">
          <label for="username" class="col-sm-2 control-label">Username</label>
          <div class="col-sm-10">
            <input id="username" class="form-control admin-form-control" v-model.trim="userFields.username">
          </div>
        </div>
        <div class="form-group">
          <label for="password" class="col-sm-2 control-label">Password</label>
          <div class="col-sm-10">
            <input type="password" id="password" class="form-control admin-form-control" v-model.trim="userFields.password">
          </div>
        </div>
        <div class="form-group">
          <label for="firstName" class="col-sm-2 control-label">First Name</label>
          <div class="col-sm-10">
            <input type="firstName" id="firstName" class="form-control admin-form-control" v-model.trim="userFields.firstName">
          </div>
        </div>
        <div class="form-group">
          <label for="lastName" class="col-sm-2 control-label">Last Name</label>
          <div class="col-sm-10">
            <input type="lastName" id="lastName" class="form-control admin-form-control" v-model.trim="userFields.lastName">
          </div>
        </div>
        <div class="form-group">
          <label for="email" class="col-sm-2 control-label">Email</label>
          <div class="col-sm-10">
            <input type="email" id="email" class="form-control admin-form-control" v-model.trim="userFields.email">
          </div>
        </div>
        <div class="btn-group">
          <button type="submit" class="btn admin-btn-primary">Register</button>
          <button type="button" class="btn btn-success" @click="$router.go(-1)">Cancel</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AdminRegister',
  data () {
    return {
      userFields: {
        isAdmin: true,
        address: '123 test',
        city: 'test',
        state: 'test',
        zip: '99999'
      },
      errors: []
    }
  },
  methods: {
    ...mapActions('auth', [
      'register'
    ]),
    onSubmit () {
      this.register({ user: this.userFields })
        .then(response => {
          this.$router.push({
            name: 'AdminLogin'
          })
        })
        .catch(e => {
          this.errors.push(e.response.data.msg || e)
        })
    }
  }
}
</script>
